import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import Grid from "@mui/material/Grid";
import { useTheme, styled } from "@mui/material/styles";
const GridContainer = t0 => {
  const $ = c(5);
  const {
    children
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme) {
    t1 = theme.spacing(4);
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = /* @__PURE__ */jsx(StyledGridContainer, {
      container: true,
      spacing: t1,
      children
    });
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const StyledGridContainer = styled(Grid, {
  shouldForwardProp: prop => !["width", "minHeight", "maxWidth", "isGrouped"].includes(prop)
})(({
  width,
  theme
}) => {
  const columnWidth = theme.sizes.grid.width;
  const spacingGrouped = theme.sizes.borderWidth[1];
  const spacingRegular = theme.spacing(2);
  return {
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "100rem",
    "&.grouped": {
      backgroundColor: theme.colors.border.primary,
      gap: spacingGrouped,
      padding: 0,
      margin: 0,
      boxShadow: "0px 4px 14px rgba(0, 0, 0, 0.05)",
      borderRadius: "12px",
      overflow: "hidden",
      // This fixes multi column grouped cards
      // but breaks the extra width and an empty background is visible on the right side.
      //   width: width
      //     ? `${width * columnWidth}rem`
      //     : 'auto',
      //   maxWidth: '100%',
      // This fixes multi column un-grouped cards
      // but they pushes them to a single row when grouped.
      width: width && width > 6 ? "fit-content" : width ? `${width * columnWidth}rem` : "auto",
      flexGrow: width ? 0 : 1,
      flexBasis: width ? "auto" : 0
    },
    "&.not-grouped": {
      borderRadius: 0,
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      gap: spacingRegular,
      boxShadow: "none"
    }
  };
});
export { GridContainer, StyledGridContainer, GridContainer as default };